angular.module('tgaAdmin').controller('CaseModalController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$uibModalStack',
  '$timeout',
  '$filter',
  'extras',
  'fileReader',
  '$translate',
  function (
    $scope,
    $state,
    $window,
    $uibModalInstance,
    $uibModalStack,
    $timeout,
    $filter,
    extras,
    fileReader,
    $translate,
  ) {
    $scope.data = {
      alerts: [],
      isOpen: [],
      closeButton: extras.closeButton,
      childAnswer: extras.childAnswer,
      answers: extras.evidence,
      game_id: extras.game_id,
      type: extras.type,
      yesno: [
        {
          id: true,
          name: 'Yes',
        },
        {
          id: false,
          name: 'No',
        },
      ],
      colors: [
        '#2F85BD',
        '#FFA100',
        '#638F73',
        '#EF5214',
        '#63B8CC',
        '#A36FAC',
        '#94BF27',
        '#526A8F',
        '#DDA46F',
        '#8F0B32',
        '#8A9DD0',
        '#004474',
      ],
      questionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        },
      ],
    };

    $scope.viewmodel = {
      answer_id: null,
      type: null,
      text: null,
      image_logo: null,
      image: null,
      video: null,
      color: null,
      response: null,
      correct: false,
      points: null,
      questions: [],
      evidence: [],
    };

    $scope.initialize = function () {
      if ($scope.data.childAnswer) {
        $scope.viewmodel = $scope.data.childAnswer;
        $scope.viewmodel.questions.forEach((question) => {
          if (question.question_type === 'multiple_choice') {
            question.max_correct = 1;
          }
        });
      }

      if ($scope.data.type === 'suspect' && $scope.data.answers.length) {
        if (!$scope.viewmodel.evidence.length) {
          $scope.viewmodel.evidence = $scope.data.answers;

          for (let i = 0; i < $scope.viewmodel.evidence.length; i++) {
            if (angular.isUndefined($scope.viewmodel.evidence[i].include)) {
              $scope.viewmodel.evidence[i].include = true;
            }
          }
        }
      }
    };

    $scope.actions = {
      submit(form) {
        form.submitted = true;
        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $uibModalStack.getTop().value.backdrop = 'static';
        $uibModalStack.getTop().value.keyboard = false;
        $scope.data.closeButton = false;
        $scope.processing = true;
        $uibModalInstance.close($scope.viewmodel);
      },
      totalIncluded() {
        for (let i = 0; i < $scope.viewmodel.evidence.length; i++) {
          if ($scope.viewmodel.evidence[i].include) {
            return false;
          }
        }

        return true;
      },
      addQuestion() {
        const question = {
          question_id: null,
          question_type: 'multiple_choice',
          question_group: null,
          text: null,
          body: null,
          image: null,
          audio: null,
          video: null,
          watch_video: null,
          response_correct: null,
          response_incorrect: null,
          response_timeout: null,
          response_correct_image: null,
          response_incorrect_image: null,
          response_timeout_image: null,
          show_results: null,
          time: 0,
          randomize_answers: false,
          interstitial: {
            name: null,
            text_color: null,
            text_shadow: false,
            bg_color: null,
          },
          answers: [
            {
              answer_id: null,
              type: null,
              text: null,
              image: null,
              response: null,
              correct: false,
              points: null,
              answers: [],
            },
            {
              answer_id: null,
              type: null,
              text: null,
              image: null,
              response: null,
              correct: false,
              points: null,
              answers: [],
            },
          ],
        };

        $scope.actions.changeQuestionType(question);
        $scope.viewmodel.questions = $scope.viewmodel.questions || [];
        $scope.viewmodel.questions.push(question);
        $scope.actions.toggleCollapse($scope.viewmodel.questions.length - 1);
      },
      changeQuestionType(question) {
        const totalAnswers = question.answers.length;

        // Set min/max answers
        if (question.question_type === 'slider') {
          question.min_answers = 2;
          question.max_answers = 5;
        } else if (question.question_type === 'image') {
          question.min_answers = 2;
          question.max_answers = 4;
        } else if (question.question_type === 'text_input') {
          question.min_answers = 1;
          question.max_answers = 10;
          question.randomize_answers = false;
        } else if (question.question_type === 'grid') {
          question.min_answers = 1;
          question.max_answers = 6;
        } else if (question.question_type === 'scramble_letter' || question.question_type === 'scramble_sentence') {
          question.min_answers = 1;
          question.max_answers = 1;
        } else if (question.question_type === 'interstitial') {
          question.min_answers = 0;
          question.max_answers = 0;
        } else if (question.question_type === 'poll') {
          question.min_answers = 2;
          question.max_answers = 4;
        } else {
          question.min_answers = 2;
          question.max_answers = 5;
        }

        // Set image vs text
        if (question.question_type === 'image') {
          for (let i = 0; i < totalAnswers; i++) {
            question.answers[i].text = null;
          }
        } else {
          for (let i = 0; i < totalAnswers; i++) {
            question.answers[i].image = null;
          }
        }

        // Set max correct
        if (question.question_type === 'multiple_select' || question.question_type === 'image') {
          question.max_correct = null;
        } else {
          question.max_correct = 1;

          const totalCorrect = $filter('filter')(
            question.answers,
            {
              correct: true,
            },
            true,
          ).length;

          if (totalCorrect > 1 || question.question_type === 'poll') {
            for (let i = 0; i < totalAnswers; i++) {
              question.answers[i].correct = false;
            }
          }
        }

        // if not poll unset show_results
        if (question.question_type !== 'poll') {
          question.show_results = null;

          if (question.question_type !== 'multiple_choice') {
            for (let i = 0; i < totalAnswers; i++) {
              question.answers[i].points = null;
            }
          }
        }

        // if poll or multiple choice points are set on the answers
        if (question.question_type === 'poll' || question.question_type === 'multiple_choice') {
          question.points_correct = null;
          question.points_incorrect = null;
        }

        if (question.answers.length > question.max_answers) {
          // Remove excess answers based on new max_answers
          question.answers.splice(question.max_answers, question.answers.length - question.max_answers);
        } else if (question.answers.length < question.min_answers) {
          // Add answers if below min_answers
          for (let i = 0; i < question.min_answers - question.answers.length; i++) {
            question.answers.push({
              answer_id: null,
              text: null,
              image: null,
              response: null,
              correct: false,
              points: null,
              next_question_hash: null,
            });
          }
        }

        // if it is not multiple choice we have to set the next_question_hash on
        // the answers to null because the next question id will come from the question
        if (question.question_type !== 'multiple_choice' && question.question_type !== 'poll') {
          for (let i = 0; i < question.answers.length; i++) {
            question.answers[i].next_question_hash = null;
          }
        }

        $scope.data.lastQuestionType = question.question_type;
      },
      toggleCollapse(index) {
        if ($scope.data.isOpen[index]) {
          $scope.data.isOpen.length = 0;
          return;
        }

        $scope.data.isOpen.length = 0;
        $scope.data.isOpen[index] = true;
        /* $timeout(function () {
            $('.modal').stop(true, false).animate({
              scrollTop: $('#modal-question-group').children('.panel').eq(index).offset().top - 120
            }, 250);
          }, 10); */
      },
      moveQuestion(from, to) {
        $scope.viewmodel.questions.splice(to, 0, $scope.viewmodel.questions.splice(from, 1)[0]);
      },
      deleteQuestion(question) {
        $scope.viewmodel.questions.splice($scope.viewmodel.questions.indexOf(question), 1);
      },
      addAnswer(question) {
        question.answers.push({
          answer_id: null,
          type: null,
          match_type: null,
          text: null,
          image: null,
          response: null,
          correct: false,
          translations: {},
          next_question_hash: null,
          points: null,
        });
      },
      checkImage(image) {
        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|svg/i;
        if (!allowed.test(ext)) {
          image.base64 = null;
          image = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 5MB.
        if (image.filesize > 5242880) {
          image.base64 = null;
          image = null;
          // image.invalid_size = true;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
            'danger',
          );
        }
      },
      changeEvidence(evidence) {
        const index = $scope.viewmodel.evidence.indexOf(evidence);
        if (index > -1) {
          $scope.viewmodel.evidence.splice(index, 1, evidence);
        }
      },
      checkAudio(audio) {
        const allowed = /audio\/mpeg|audio\/mp3/.test(audio.file.type);

        if (!allowed) {
          audio = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        if (audio.file.size > 5242880) {
          audio = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Audio files cannot be more than 5 MB in size.',
            'danger',
          );
          return;
        }

        fileReader.readAsDataUrl(audio.file, $scope).then((result) => {
          audio.base64 = result;
          audio.filetype = audio.file.type;
          audio.filename = audio.file.name;
        });
      },
      checkVideo(video) {
        const allowed = /video\/mp4/.test(video.file.type);

        if (!allowed) {
          video.file = null; // this is needed for some reason
          video = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        if (video.file.size > 104857600) {
          video.file = null; // this is needed for some reason
          video = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Video files cannot be more than 30 MB in size.',
            'danger',
          );
          return;
        }

        video.url = URL.createObjectURL(video.file);
      },
      videoEmbed(video) {
        if (video.url.includes('vimeo')) {
          const result = video.url.match(
            // eslint-disable-next-line max-len
            /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i,
          );
          video.url = `https://player.vimeo.com/video/${result[1]}`;
        } else if (video.url.includes('youtu')) {
          if (!video.url.includes('embed')) {
            const expr = /(youtu\.be\/|[?&]v=)([^&]+)/;
            video.url = `https://www.youtube.com/embed/${video.url.match(expr)[2]}`;
          }
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };
    $scope.initialize();
  },
]);
